import { defineComponent as _defineComponent } from 'vue'
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import { computed } from 'vue';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectActionApplyError',
  props: {
  alreadyApplied: Boolean,
  notAcceptingOffers: Boolean
},
  setup(__props) {

const props = __props;




const { t } = useI18n();

const errorText = computed(() => (props.notAcceptingOffers ? t('project-forum.apply-box.no-offers-accepted') : t('project-forum.apply-box.already-applied')));


return { __sfc: true,props, t, errorText, BCXMarkdown }
}

})